import _ from 'lodash';
import domains from '../containers/Domains';
import { getLocalStorageDataOrFetch } from './fbCallManager';

const endpoint = domains.fbEndpoint;

export const getAdPreview = async (id, adFormat, token) => {
  const parameters = {
    access_token: token,
    id,
    fields: 'body',
    adFormat
  };

  const query = _.template(
    `${endpoint}<%= id%>/previews?ad_format=<%= adFormat%>&fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getAdGeneratePreview = async (
  accountId,
  creative,
  adFormat,
  token
) => {
  const jsonObject = JSON.stringify(creative);
  const parameters = {
    access_token: token,
    creative: jsonObject,
    adFormat
  };

  const query = _.template(
    `${endpoint}act_${accountId}/generatepreviews?ad_format=<%= adFormat%>&creative=<%= creative%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getThumbnailByAssetId = async (assetId, token) => {
  const parameters = {
    access_token: token,
    id: assetId,
    fields: 'thumbnails'
  };
  const query = _.template(
    `${endpoint}<%= id%>?fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};



// WEBPACK FOOTER //
// ./src/fbApi/AdPreview.js